<mat-tab-group [(selectedIndex)]="selectedTab" animationDuration="0ms">

  <!-- ABOUT TAB -->
  <mat-tab label="About">
    <div class="tab-content about-container">
      <h2>About NW Hub</h2>

      <section class="about-section about-disclaimer">
        <h3>Important Disclaimer</h3>
        <p>
          Unlike the earlier mechanics pages and mod write-ups which went through extensive
          in-game testing and verification, the newer content on this site has had
          <strong>less checking, less time, and less energy</strong> put into validation.
        </p>
        <p>
          But even without that caveat &mdash; <strong>everything here should always be verified
          and double-checked.</strong> Never rely on a single source for anything. I actively
          encourage everyone to question, contest, and correct anything written
          on this site. If something looks wrong, it very well might be.
        </p>
      </section>

      <section class="about-section">
        <h3>What is this?</h3>
        <p>
          NW Hub is a resource site for <strong>Neverwinter</strong> players.
          It provides tools, data listings, and reference material including a
          <a routerLink="/characters">Character simulator</a> with build comparison,
          a <a routerLink="/logparser">Combat log parser</a>, combat
          mechanics calculators, mount &amp; insignia databases, companion listings,
          build tools, profession recipes, and more.
        </p>
      </section>

      <section class="about-section">
        <h3>Found a bug? Have feedback?</h3>
        <p>
          If you spot any errors, have suggestions, or just want to say hi, feel free
          to ping <strong>janne0</strong> on Discord, or find me on the PE server:
        </p>
        <ul class="discord-list">
          <li>
            <a href="https://discord.gg/MssfZjTPUj" target="_blank" rel="noopener noreferrer">
              Official PE Discord
            </a>
          </li>
        </ul>
      </section>

      <section class="about-section about-cookies">
        <h3>Privacy & Cookies</h3>
        <p>
          This site uses cookies for analytics to help improve the experience and find bugs.
          No personal data is collected.
        </p>
        <p>
          Your current preference:
          <strong>{{ consent.status() === 'granted' ? 'Accepted' : consent.status() === 'denied' ? 'Declined' : 'Not set' }}</strong>
        </p>
        <button mat-stroked-button (click)="consent.reset()">Change cookie preference</button>
      </section>
    </div>
  </mat-tab>

  <!-- WHAT'S NEW TAB -->
  <mat-tab label="What's New">
    <div class="tab-content whats-new-container">
      <h2>What's New</h2>
      <p class="whats-new-intro">
        Recent additions and changes to NW Hub. Most recent first.
      </p>
      <section class="whats-new-entry" *ngFor="let entry of whatsNewEntries">
        <h3>{{ entry.date }}</h3>
        <ul>
          <li *ngFor="let item of entry.items">{{ item }}</li>
        </ul>
      </section>
    </div>
  </mat-tab>

  <!-- CREDITS TAB -->
  <mat-tab label="Credits">
    <div class="tab-content credits-container">
      <h2>Credits &amp; Data Sources</h2>

      <section class="credit-entry">
        <h3>Rainer</h3>
        <p>
          Mount, insignia, and companion listing data. Artifact data sourced from
          <a href="https://www.patreon.com/RainerNW/posts?tag=CharacterBuilder" target="_blank" rel="noopener noreferrer">Rainer's Character Builder</a>.
        </p>
        <p>
          Rainer also runs a
          <a href="https://www.youtube.com/channel/UCdftDhXyVy4Y4OGF7ktw5Yg" target="_blank" rel="noopener noreferrer">YouTube channel</a>
          with guides, testing, and build showcases, and a
          <a href="https://discord.gg/uSUrZSv8Sg" target="_blank" rel="noopener noreferrer">Discord server</a>
          with an active community of players sharing builds, data, and advice.
        </p>
      </section>

      <section class="credit-entry">
        <h3>Lockbox &amp; Pack Data</h3>
        <p>
          Lockbox content data compiled from in-game screenshots, the
          <a href="https://neverwinter.fandom.com/wiki/Neverwinter_Wiki" target="_blank" rel="noopener noreferrer">Neverwinter Wiki</a>,
          and
          <a href="https://docs.google.com/spreadsheets/d/1s66hDVSHkdwmbRmkQi4fAW_a7mh6y6TVK7hIXazs8LY/edit?gid=0#gid=0" target="_blank" rel="noopener noreferrer">Asure's lockbox tracking spreadsheet</a>
          (Synergy guild).
        </p>
      </section>

      <section class="credit-entry">
        <h3>Neverwinter Wiki</h3>
        <p>
          The <a href="https://neverwinter.fandom.com/wiki/Neverwinter_Wiki" target="_blank" rel="noopener noreferrer">NW Fandom Wiki</a>
          is used as a reference for icon identification, general game info, dates, and miscellania.
        </p>
      </section>

      <section class="credit-entry">
        <h3>Guild &amp; Friends</h3>
        <p>
          Thanks to guildmates and friends in-game for sharing knowledge, testing mechanics,
          providing screenshots, and helping verify data.
        </p>
      </section>

      <section class="credit-entry">
        <h3>Game Assets</h3>
        <p>
          Icons and textures sourced from the official Neverwinter Wiki, official asset shares,
          and other community resources. All game assets remain the property of Cryptic Studios / Gearbox.
        </p>
      </section>
    </div>
  </mat-tab>

</mat-tab-group>
